import React, { useContext, useEffect, useState } from "react";
import { FiCheck, FiX, FiPlus, FiMinus } from "react-icons/fi";

import { Container } from "./styles";

import QuestionContext from "../../contexts/QuestionContext";
import { AnalistCheckListTypes } from "./types";

function AnalistChecklist({
	id = 0,
	title,
	handleAnswer,
	handleJustificationChange,
	selectedDocumentId,
	document,
}: AnalistCheckListTypes) {
	const { stepThreeValues } = useContext(QuestionContext);

	const [show, setShow] = useState(false);
	const [value, setValue] = useState<number | null>(null);
	const [justification, setJustification] = useState<string | null>(null);

	useEffect(() => {
		const answers = stepThreeValues[selectedDocumentId];
		setValue(answers && answers[id] ? answers[id].answer : null);
		setJustification(
			answers && answers[id] ? answers[id].justification : "",
		);
	}, []);

	return (
		<Container>
			<div className='quest'>
				<p>{title}</p>
				<div>
					<FiCheck
						className={value === 1 ? "checked" : "img"}
						id='check'
						onClick={() => {
							setShow(false);
							handleAnswer(1);
							setValue(1);
						}}
					/>
					<FiX
						className={value === 2 ? "rejected" : "img"}
						id='x'
						onClick={() => {
							setShow(true);
							handleAnswer(2);
							setValue(2);
						}}
					/>
					{show === false ? (
						<FiPlus
							onClick={() => setShow(!show)}
							className='img'
						/>
					) : (
						<FiMinus
							onClick={() => setShow(!show)}
							className='img'
						/>
					)}
				</div>
			</div>
			<div className='sub-wrapper'>
				{show || justification ? (
					<div className='input-wrapper'>
						<label>
							instrução de justificativa
							<textarea
								placeholder='Justificativa...'
								defaultValue={justification || ""}
								onChange={(e) => {
									const justification = e.target.value;

									setJustification(justification);
									handleJustificationChange(
										id,
										justification,
										document,
									);
								}}
							/>
						</label>
					</div>
				) : null}
			</div>
		</Container>
	);
}

export default AnalistChecklist;
